import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-foreground-900/40 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className={`font-heading text-xl md:text-2xl font-bold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-900' : 'text-white'}`}
          >
            Hipobuy<span className="font-light italic">Spreadsheet</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-800 hover:text-accent-600' : 'text-white/95 hover:text-white'}`}
            >
              Accueil
            </Link>
            <a
              href="#categories"
              className={`text-sm font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-800 hover:text-accent-600' : 'text-white/95 hover:text-white'}`}
            >
              Catégories
            </a>
            <a
              href="#guide"
              className={`text-sm font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-800 hover:text-accent-600' : 'text-white/95 hover:text-white'}`}
            >
              Guide
            </a>
            <a
              href="#articles"
              className={`text-sm font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-800 hover:text-accent-600' : 'text-white/95 hover:text-white'}`}
            >
              Articles
            </a>
            <Link
              to="/article/guide-achat-hipobuy-spreadsheet"
              className={`text-sm font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${scrolled ? 'text-foreground-800 hover:text-accent-600' : 'text-white/95 hover:text-white'}`}
            >
              Guide d'Achat
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer bg-accent-500 text-background-50 hover:bg-accent-400 shadow-lg shadow-accent-500/20"
            >
              Buy It Now
            </a>
          </nav>

          <div className="md:hidden flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap bg-accent-500 text-background-50 cursor-pointer"
            >
              Buy Now
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`w-9 h-9 flex items-center justify-center cursor-pointer ${scrolled ? 'text-foreground-800' : 'text-white'}`}
              aria-label="Menu"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed top-16 left-0 right-0 bg-foreground-900/95 backdrop-blur-md border-t border-background-50/10 overflow-y-auto max-h-[calc(100vh-4rem)] touch-pan-y">
          <div className="px-6 py-4 pb-10 space-y-1">
            <Link to="/" onClick={() => setMobileOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white/90 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors">Accueil</Link>
            <a href="#categories" onClick={() => setMobileOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white/90 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors">Catégories</a>
            <a href="#guide" onClick={() => setMobileOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white/90 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors">Guide</a>
            <a href="#articles" onClick={() => setMobileOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white/90 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors">Articles</a>
            <Link to="/article/guide-achat-hipobuy-spreadsheet" onClick={() => setMobileOpen(false)} className="block px-4 py-3 text-sm font-semibold text-white/90 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors">Guide d'Achat</Link>
            <div className="pt-2 border-t border-background-50/10">
              <p className="px-4 py-2 text-xs font-semibold text-white/50 uppercase tracking-wider">Catégories produits</p>
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  onClick={() => setMobileOpen(false)}
                  className="block px-4 py-2.5 text-sm text-white/80 hover:bg-background-50/10 rounded-lg cursor-pointer transition-colors"
                >
                  {cat.nameFr}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}